export default function lowercaseEnum(enumValue) {
  return {
    serialize(value) {
      return value && value.toLowerCase();
    },
    deserialize(value) {
      return value ? enumValue[value.toUpperCase()] : null;
    }
  };
}